
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { class_type, bool_type, int32_type, list_type, record_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { sortBy, map, findIndex, contains, filter, append, singleton, tryFind, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { comparePrimitives, compareArrays, safeHash, equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { map as map_1, bind, defaultArgWith, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { tryFind as tryFind_1, ofList, empty } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";

export class InventoryKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Set", "ToolWithQuantity", "Consumable"];
    }
}

export function InventoryKind_$reflection() {
    return union_type("Shared.InventoryStates.InventoryKind", [], InventoryKind, () => [[], [], [], []]);
}

export function InventoryKind__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "set";
        case 2:
            return "tool_with_quantity";
        case 3:
            return "consumable";
        default:
            return "tool";
    }
}

export function InventoryKind__ToI18nString(this$) {
    return concat("inventory_state.kind.", ...InventoryKind__get_Key(this$));
}

export const InventoryKindModule_all = ofArray([new InventoryKind(0, []), new InventoryKind(1, []), new InventoryKind(2, []), new InventoryKind(3, [])]);

export function InventoryKindModule_tryParse(key) {
    return tryFind((kind) => (InventoryKind__get_Key(kind) === key), InventoryKindModule_all);
}

export class InventoryBaseState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Active", "InMaintenance", "Retired", "Lost"];
    }
}

export function InventoryBaseState_$reflection() {
    return union_type("Shared.InventoryStates.InventoryBaseState", [], InventoryBaseState, () => [[], [], [], []]);
}

export function InventoryBaseState__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "in_maintenance";
        case 2:
            return "retired";
        case 3:
            return "lost";
        default:
            return "active";
    }
}

export function InventoryBaseState__ToI18nString(this$) {
    return concat("general.", ...InventoryBaseState__get_Key(this$));
}

export const InventoryBaseStateModule_all = ofArray([new InventoryBaseState(0, []), new InventoryBaseState(1, []), new InventoryBaseState(2, []), new InventoryBaseState(3, [])]);

export function InventoryBaseStateModule_tryParse(key) {
    return tryFind((baseState) => (InventoryBaseState__get_Key(baseState) === key), InventoryBaseStateModule_all);
}

export function InventoryBaseStateModule_allowedFor(kind) {
    switch (kind.tag) {
        case 2:
        case 3:
            return ofArray([new InventoryBaseState(0, []), new InventoryBaseState(2, [])]);
        default:
            return InventoryBaseStateModule_all;
    }
}

export class InventoryAction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Assign", "Reserve", "RequestReturn", "Return", "ChangeStorage", "ChangeBusinessUnit", "ReportProblem", "StartProcedure", "RecordInspection", "CountInStocktaking", "AddToDispolist", "Update", "ManageDocuments", "ManageIdentifiers"];
    }
}

export function InventoryAction_$reflection() {
    return union_type("Shared.InventoryStates.InventoryAction", [], InventoryAction, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function InventoryAction__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "reserve";
        case 2:
            return "request_return";
        case 3:
            return "return";
        case 4:
            return "change_storage";
        case 5:
            return "change_business_unit";
        case 6:
            return "report_problem";
        case 7:
            return "start_procedure";
        case 8:
            return "record_inspection";
        case 9:
            return "count_in_stocktaking";
        case 10:
            return "add_to_dispolist";
        case 11:
            return "update";
        case 12:
            return "manage_documents";
        case 13:
            return "manage_identifiers";
        default:
            return "assign";
    }
}

export function InventoryAction__ToI18nString(this$) {
    return concat("inventory_state.action.", ...InventoryAction__get_Key(this$));
}

export const InventoryActionModule_all = ofArray([new InventoryAction(0, []), new InventoryAction(1, []), new InventoryAction(2, []), new InventoryAction(3, []), new InventoryAction(4, []), new InventoryAction(5, []), new InventoryAction(6, []), new InventoryAction(7, []), new InventoryAction(8, []), new InventoryAction(9, []), new InventoryAction(10, []), new InventoryAction(11, []), new InventoryAction(12, []), new InventoryAction(13, [])]);

export function InventoryActionModule_tryParse(key) {
    return tryFind((action) => (InventoryAction__get_Key(action) === key), InventoryActionModule_all);
}

export class InventoryStateReference extends Record {
    constructor(Key, Name) {
        super();
        this.Key = Key;
        this.Name = Name;
    }
}

export function InventoryStateReference_$reflection() {
    return record_type("Shared.InventoryStates.InventoryStateReference", [], InventoryStateReference, () => [["Key", string_type], ["Name", string_type]]);
}

export class InventoryStateDefinition extends Record {
    constructor(Key, Name, Description, Color, BaseState, AppliesTo, AllowedActions, SortOrder, IsSystem, IsArchived) {
        super();
        this.Key = Key;
        this.Name = Name;
        this.Description = Description;
        this.Color = Color;
        this.BaseState = BaseState;
        this.AppliesTo = AppliesTo;
        this.AllowedActions = AllowedActions;
        this.SortOrder = (SortOrder | 0);
        this.IsSystem = IsSystem;
        this.IsArchived = IsArchived;
    }
}

export function InventoryStateDefinition_$reflection() {
    return record_type("Shared.InventoryStates.InventoryStateDefinition", [], InventoryStateDefinition, () => [["Key", string_type], ["Name", string_type], ["Description", string_type], ["Color", string_type], ["BaseState", InventoryBaseState_$reflection()], ["AppliesTo", list_type(InventoryKind_$reflection())], ["AllowedActions", list_type(InventoryAction_$reflection())], ["SortOrder", int32_type], ["IsSystem", bool_type], ["IsArchived", bool_type]]);
}

export function InventoryStateDefinitionModule_systemKey(baseState) {
    return InventoryBaseState__get_Key(baseState);
}

export function InventoryStateDefinitionModule_isSystemKey(key) {
    return InventoryBaseStateModule_tryParse(key) != null;
}

function InventoryStateDefinitionModule_systemName(baseState) {
    switch (baseState.tag) {
        case 1:
            return "In Wartung";
        case 2:
            return "Ausgemustert";
        case 3:
            return "Verloren";
        default:
            return "Aktiv";
    }
}

function InventoryStateDefinitionModule_systemColor(baseState) {
    switch (baseState.tag) {
        case 1:
            return "#f59e0b";
        case 2:
            return "#6b7280";
        case 3:
            return "#dc2626";
        default:
            return "#16a34a";
    }
}

const InventoryStateDefinitionModule_blockedWhileUnavailable = singleton(new InventoryAction(0, []));

const InventoryStateDefinitionModule_blockedWhileOutOfStock = append(InventoryStateDefinitionModule_blockedWhileUnavailable, ofArray([new InventoryAction(1, []), new InventoryAction(9, []), new InventoryAction(10, [])]));

function InventoryStateDefinitionModule_without(blocked) {
    return filter((action) => !contains(action, blocked, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), InventoryActionModule_all);
}

export function InventoryStateDefinitionModule_systemAllowedActions(baseState) {
    switch (baseState.tag) {
        case 1:
            return InventoryStateDefinitionModule_without(InventoryStateDefinitionModule_blockedWhileUnavailable);
        case 2:
        case 3:
            return InventoryStateDefinitionModule_without(InventoryStateDefinitionModule_blockedWhileOutOfStock);
        default:
            return InventoryActionModule_all;
    }
}

export function InventoryStateDefinitionModule_systemAppliesTo(baseState) {
    return filter((kind) => contains(baseState, InventoryBaseStateModule_allowedFor(kind), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), InventoryKindModule_all);
}

export function InventoryStateDefinitionModule_systemSortOrder(baseState) {
    return findIndex((candidate) => equals(candidate, baseState), InventoryBaseStateModule_all) | 0;
}

export function InventoryStateDefinitionModule_systemDefinition(baseState) {
    return new InventoryStateDefinition(InventoryStateDefinitionModule_systemKey(baseState), InventoryStateDefinitionModule_systemName(baseState), "", InventoryStateDefinitionModule_systemColor(baseState), baseState, InventoryStateDefinitionModule_systemAppliesTo(baseState), InventoryStateDefinitionModule_systemAllowedActions(baseState), InventoryStateDefinitionModule_systemSortOrder(baseState), true, false);
}

export const InventoryStateDefinitionModule_systemDefinitions = map(InventoryStateDefinitionModule_systemDefinition, InventoryBaseStateModule_all);

export function InventoryStateDefinitionModule_tryFind(key, definitions) {
    return tryFind((definition) => (definition.Key === key), definitions);
}

export function InventoryStateDefinitionModule_reference(definition) {
    return new InventoryStateReference(definition.Key, definition.Name);
}

export function InventoryStateDefinitionModule_allows(action, definition) {
    return contains(action, definition.AllowedActions, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

export function InventoryStateDefinitionModule_appliesTo(kind, definition) {
    return contains(kind, definition.AppliesTo, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

export function InventoryStateDefinitionModule_historyReference(definition) {
    if (definition.IsSystem) {
        return undefined;
    }
    else {
        return InventoryStateDefinitionModule_reference(definition);
    }
}

export function InventoryStateDefinitionModule_isDefaultState(definition) {
    if (definition.IsSystem) {
        return equals(definition.BaseState, new InventoryBaseState(0, []));
    }
    else {
        return false;
    }
}

export function InventoryStateDefinitionModule_resolve(key, baseState, definitions) {
    return defaultArg(InventoryStateDefinitionModule_tryFind(key, definitions), InventoryStateDefinitionModule_systemDefinition(baseState));
}

export function InventoryStateDefinitionModule_selectable(customStatesEnabled, kind, definitions) {
    return sortBy((definition_1) => [definition_1.SortOrder, definition_1.Key], filter((definition) => {
        if (!definition.IsArchived && InventoryStateDefinitionModule_appliesTo(kind, definition)) {
            if (definition.IsSystem) {
                return true;
            }
            else {
                return customStatesEnabled;
            }
        }
        else {
            return false;
        }
    }, definitions), {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    });
}

export class InventoryStateContext extends Record {
    constructor(Definitions, StateKeys) {
        super();
        this.Definitions = Definitions;
        this.StateKeys = StateKeys;
    }
}

export function InventoryStateContext_$reflection() {
    return record_type("Shared.InventoryStates.InventoryStateContext", [], InventoryStateContext, () => [["Definitions", list_type(InventoryStateDefinition_$reflection())], ["StateKeys", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]]);
}

export const InventoryStateContextModule_systemOnly = new InventoryStateContext(InventoryStateDefinitionModule_systemDefinitions, empty({
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
}));

export function InventoryStateContextModule_create(definitions, stateKeys) {
    return new InventoryStateContext(definitions, ofList(stateKeys, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

export function InventoryStateContextModule_stateKey(context, inventoryId, baseState) {
    return defaultArg(tryFind_1(inventoryId, context.StateKeys), InventoryStateDefinitionModule_systemKey(baseState));
}

export function InventoryStateContextModule_resolve(context, inventoryId, baseState) {
    return InventoryStateDefinitionModule_resolve(InventoryStateContextModule_stateKey(context, inventoryId, baseState), baseState, context.Definitions);
}

export function InventoryStateContextModule_effective(context, inventoryId, baseState) {
    return defaultArgWith(bind((key) => InventoryStateDefinitionModule_tryFind(key, context.Definitions), tryFind_1(inventoryId, context.StateKeys)), () => InventoryStateDefinitionModule_resolve(InventoryStateDefinitionModule_systemKey(baseState), baseState, context.Definitions));
}

export class WriteInventoryStateDto extends Record {
    constructor(Name, Description, Color, BaseState, AppliesTo, AllowedActions) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.Color = Color;
        this.BaseState = BaseState;
        this.AppliesTo = AppliesTo;
        this.AllowedActions = AllowedActions;
    }
}

export function WriteInventoryStateDto_$reflection() {
    return record_type("Shared.InventoryStates.WriteInventoryStateDto", [], WriteInventoryStateDto, () => [["Name", string_type], ["Description", string_type], ["Color", string_type], ["BaseState", InventoryBaseState_$reflection()], ["AppliesTo", list_type(InventoryKind_$reflection())], ["AllowedActions", list_type(InventoryAction_$reflection())]]);
}

export function WriteInventoryStateDtoModule_toDefinition(key, sortOrder, dto) {
    return new InventoryStateDefinition(key, dto.Name, dto.Description, dto.Color, dto.BaseState, dto.AppliesTo, dto.AllowedActions, sortOrder, false, false);
}

export class InventoryStateOrderDto extends Record {
    constructor(Keys) {
        super();
        this.Keys = Keys;
    }
}

export function InventoryStateOrderDto_$reflection() {
    return record_type("Shared.InventoryStates.InventoryStateOrderDto", [], InventoryStateOrderDto, () => [["Keys", list_type(string_type)]]);
}

export class InventoryStateUsage extends Record {
    constructor(Key, Count) {
        super();
        this.Key = Key;
        this.Count = (Count | 0);
    }
}

export function InventoryStateUsage_$reflection() {
    return record_type("Shared.InventoryStates.InventoryStateUsage", [], InventoryStateUsage, () => [["Key", string_type], ["Count", int32_type]]);
}

export class InventoryStatesDto extends Record {
    constructor(States, UsageCounts) {
        super();
        this.States = States;
        this.UsageCounts = UsageCounts;
    }
}

export function InventoryStatesDto_$reflection() {
    return record_type("Shared.InventoryStates.InventoryStatesDto", [], InventoryStatesDto, () => [["States", list_type(InventoryStateDefinition_$reflection())], ["UsageCounts", list_type(InventoryStateUsage_$reflection())]]);
}

export function InventoryStatesDtoModule_usageOf(key, dto) {
    return defaultArg(map_1((_arg) => (_arg.Count | 0), tryFind((usage) => (usage.Key === key), dto.UsageCounts)), 0) | 0;
}

